module.exports = __webpack_public_path__ + "img/1_016.2cb4350c.jpg";